// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { FormInputWrapper } from "@ces/MobiusOverrides/FormField";
import { headerStyles } from "@ces/Overrides/Pages/Header";
import { DivWrapper } from "@ces/XDL/constants";
import { color, companyLogoItem, layoutContainer, xScreen } from "@ces/XDL/Utilities";
import { ContentWrapper } from "@insite/content-library/Widgets/Basic/RichContent";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { getProp } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

headerStyles.page = {
    fullWidth: [true, true, true, true, true],
    padding: 0,
    css: css`
        box-shadow: 0 1px 0 0 ${getColor("common.ui11")};
        z-index: ${getProp("theme.zIndex.header")};
        position: relative;
    `,
};

headerStyles.container = {
    css: css`
        background-color: ${getColor("common.background")};
        display: grid;
        gap: 22px;
        .wrapper,
        .wrapper img {
            // Make logo take full width
            max-width: 100%;
            max-height: 75px;
        }
        padding: 12px 0;
        ${({ isCheckoutPage }: any) => (isCheckoutPage ? "padding: 8px 0;" : "")}
        grid-template-columns: 204px minmax(0, 1fr);
        align-items: center;
        ${layoutContainer}

        ${xScreen("lte", "md")} {
            ${({ isCheckoutPage }: any) =>
                !isCheckoutPage
                    ? "grid-template-columns: 30px 108px minmax(0, 1fr);"
                    : "grid-template-columns: 108px 1fr;"}
            gap: 32px;
            padding: 8px 0;
            .wrapper,
            .wrapper img {
                // Make logo take full width
                max-width: 100%;
                max-height: 40px;
            }
        }
        ${xScreen("lte", "xs")} {
            gap: 16px;
        }
    `,
};

headerStyles.headerWrapper = {
    css: css`
        &&&& {
            ${xScreen("lte", "md")} {
                position: sticky;
                top: 0;
                z-index: ${getProp("theme.zIndex.header")};
            }

            @media print {
                display: none;
            }
        }
    `,
};

headerStyles.printLogo = companyLogoItem;

headerStyles.MainHeaderContainer = {
    css: css`
        ${({ isCheckoutPage }: any) => (isCheckoutPage ? "display: none;" : "display: flex;")}
        flex-direction: column;
        gap: 19px;
        ${xScreen("lte", 767)} {
            flex-direction: row;
            justify-content: end;
        }
    `,
};

headerStyles.upperLineHeader = {
    css: css`
        display: grid;
        gap: 20px;
        align-items: center;
        grid-template-columns: minmax(0, 884px) minmax(0, 200px);
        justify-content: space-between;
        ${DivWrapper} > div {
            gap: 0;
        }
        ${xScreen("lte", "md")} {
            grid-template-columns: 1fr auto;
            &&&& {
                ${DivWrapper} > div {
                    flex-wrap: nowrap;
                    gap: 20px;
                }
            }
        }
        ${xScreen("lt", "sm")} {
            grid-template-columns: auto auto;
        }
    `,
};

headerStyles.bottomLineHeader = {
    css: css`
        display: flex;
        align-items: center;
    `,
};

headerStyles.headerCustomButtons = {
    css: css`
        ${DivWrapper} {
            display: flex;
        }
    `,
};

headerStyles.rightSide = {
    css: css`
        div.wrapper {
            ${xScreen("lte", "xs")} {
                display: flex;
                flex-direction: column;
            }
        }
        ${TypographyStyle} {
            margin-bottom: 0;
            font-size: 12px;
            line-height: 13px;
            color: ${color("common.black")} !important;
            text-align: right;
            ${xScreen("lte", "md")} {
                font-size: 10px;
                line-height: 12px;
            }
        }
        ${ContentWrapper} {
            display: flex;
            align-items: center;
        }
        margin-left: auto;
    `,
};
